module.exports = __webpack_public_path__ + "img/systemPlatform.1be874c0.png";